import {
    ArrowRight,
    Clock,
    FileSearch,
    ShieldCheck,
} from 'lucide-react';

import { Link } from 'react-router-dom';

export default function ServicesHeroSection() {
    const trustItems = [
        {
            Icon: FileSearch,
            text: 'Données issues de sources publiques',
        },
        {
            Icon: Clock,
            text: 'Mise à jour régulière',
        },
        {
            Icon: ShieldCheck,
            text: 'Service privé indépendant',
        },
    ];

    return (
        <section className="relative overflow-hidden bg-white py-14 md:py-20 lg:py-24
    after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-full
    after:bg-[linear-gradient(to_right,transparent_0%,#b20303_20%,#b20303_80%,transparent_100%)]">
            {/* Décoration de fond */}
            <div
                aria-hidden="true"
                className="pointer-events-none absolute -top-16 -right-32 -bottom-16 z-0 hidden w-[55%] lg:block"
                
            />

            <div className="relative z-10 container mx-auto max-w-6xl px-4">
                <div className="max-w-3xl">
                    {/* Sur-titre */}
                    <span className="mb-4  text-[#b20303] inline-block text-xs font-bold tracking-[0.18em] text-accent uppercase">
                        Nos services
                    </span>

                    {/* Titre */}
                    <h1 className="mb-5 font-serif text-[29px] leading-[45px] font-semibold tracking-[-0.015em] text-foreground">
                        Toutes les données légales et administratives de votre
                        entreprise,

                        <span className="block text-[#b20303]">
                            centralisées dans un portail unique.
                        </span>
                    </h1>

                    {/* Description */}
                    <p className="mb-8 max-w-2xl text-[17px] leading-relaxed text-ink-soft">
                        Annonces FOSC (Feuille officielle suisse du commerce),
                        extraits du Registre du Commerce, solvabilité, marques…
                        retrouvez en quelques clics les informations publiques
                        disponibles sur les entreprises suisses.
                    </p>

                    {/* Boutons */}
                    <div className="flex flex-wrap items-center gap-3">
                        <Link
                            to="/recherche"
                            className="inline-flex h-12 items-center gap-2 rounded-xl bg-[#b20303] px-6 text-[15px] font-bold text-white shadow-[0_8px_22px_rgba(178,3,3,0.35)] transition hover:-translate-y-px hover:bg-[#950202] hover:shadow-[0_12px_28px_rgba(178,3,3,0.45)]"
                        >
                            Rechercher une entreprise

                            <ArrowRight
                                className="h-4 w-4"
                                strokeWidth={2.6}
                            />
                        </Link>

                        {/* Lien vers une section de la même page */}
                        <a
                            href="#formule"
                            className="inline-flex h-12 items-center gap-2 rounded-xl border border-border bg-card px-6 text-[15px] font-semibold text-foreground transition hover:bg-muted/40"
                        >
                            Découvrir l&apos;abonnement
                        </a>
                    </div>

                    {/* Éléments de confiance */}
                    <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3">
                        {trustItems.map(({ Icon, text }) => (
                            <span
                                key={text}
                                className="flex items-center gap-2 text-[13.5px] font-medium text-ink-soft"
                            >
                                <span className="flex h-7 w-7 items-center justify-center rounded-lg border border-cream-edge bg-cream text-primary">
                                    <Icon
                                        className="h-[14px] w-[14px] text-[#b20303]"
                                        strokeWidth={2}                    />
                                </span>

                                {text}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}